module.exports = __webpack_public_path__ + "img/index.702050b5.png";